import { stylesheet } from 'typestyle';
import { colors, font } from '../../assets/styles';

const styles = stylesheet({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '84px',
    padding: '0px 24px',
    color: colors.white,
    backgroundColor: colors.darkBlueBackground,
    zIndex: 5,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerLeftIcon: {
    height: 24,
    width: 24,
    marginRight: 16,
  },
  headerText: {
    fontWeight: font.weight.regular,
    fontSize: 20,
  },
  headerRight: {
    textAlign: 'end',
  },
  infoIcon: {
    width: 40,
    height: 'auto',
  },
  buttonWithIcon: {
    border: 'none',
    display: 'flex',
    padding: '5px 10px',
    background: 'none',
    flexDirection: 'column',
    alignItems: 'center',
  },
  contactsLookupWrapper: {
    padding: '20px 10px 0 10px',
    position: 'sticky',
    top: 0,
    background: 'white',
  },
  displayFlexWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  searchBar: {
    appearance: 'none',
    boxShadow: 'none',
    borderRadius: 'none',
    display: 'flex',
    padding: '10px 10px 10px 30px',
    border: '1px solid #202737'
  },
  contactsWrapper: {
    padding: '0 10px',
    flex: 1,
  }
});

export default styles;
